import {
  action,
  computed,
  IObservableArray,
  makeObservable,
  observable,
} from 'mobx';
import { GalleryFile } from './gallery-file';
import { AttachmentFile } from './attachment-file';

export class GalleryFileCollection {
  @observable initialIndex: number = 0;
  @observable showCarousel: boolean = false;
  @observable selectedFile: GalleryFile | null = null;
  @observable files: IObservableArray<GalleryFile> = observable([]);
  abortController?: AbortController;

  constructor() {
    makeObservable(this);
  }

  @computed get fileIndexMap(): { [key: number]: number } {
    return this.files.reduce((acc, file, index) => {
      acc[file.id] = index;
      return acc;
    }, {} as { [key: number]: number });
  }

  @action togglePreview = () => {
    this.showCarousel = !this.showCarousel;
  };

  @action selectFile = (fileId?: number) => {
    if (fileId === undefined) {
      this.selectedFile = this.files[0];
    } else {
      this.selectedFile = this.files[this.fileIndexMap[fileId]];
    }
  };

  @action pickFile = async (fileId?: number) => {
    if (!fileId) return;
    this.selectFile(fileId);
    this.setInitialIndex(this.selectedFile?.fileId)
  };

  @action abort() {
    this.abortController?.abort();
    this.abortController = undefined;
  }

  @action closeCarousel = () => {
    this.showCarousel = false;
    this.abort();
  };


  @action initGallery = async (
    files: AttachmentFile[] | GalleryFile[] = [],
    assetId?: number,
    initFileId?: number,
  ) => {
    try {
      await (async () => {
        this.files.replace(
          files.map(file => new GalleryFile(file, assetId, file.id))
        )
      })();

      if (!initFileId) return;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in initGallery:', error);
      this.closeCarousel();
      throw new Error('System Error: Failed to initialize gallery');
    }
  };


  @action setInitialIndex = (fileId?: number) => {
    this.initialIndex = fileId ? this.fileIndexMap[fileId] : 0;
  };


}
